import { StandardRecordForm } from '../create/components/standard-record-form';
import { Schema } from '../create/components/standard-record-form.schema';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useUpdateStandardRecordMutation } from '../mutations';
import { useAuthentication } from '~/hooks/useAuthentication';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useStandardRecordQuery } from '../queries';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';

export const Page = withPrivateRoute(({ user }) => {
  const { id } = useParams(idParamSchema.parse);
  const { data } = useStandardRecordQuery(id);
  const { isSuperUser } = useAuthentication();

  const mutation = useUpdateStandardRecordMutation();
  const navigate = useNavigate();

  const defaultDistrict = user.permissions.districts_admin.length ? user.permissions.districts_admin[0].id : null;

  async function onSubmit(payload: Schema) {
    await mutation.mutateAsync({ id, ...payload, district: isSuperUser ? payload.district : defaultDistrict });
    navigate('/admin/standard-records');
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera standardrekord" />

      <PageLayout.Section>
        <StandardRecordForm
          isLoading={mutation.isPending}
          onSubmit={onSubmit}
          mode="edit"
          defaultValues={{
            district: data.district?.id,
            age_category: data.age_category?.id,
            date: data.date,
            competition_type: data.competition_type?.id,
            discipline: data.discipline,
            weight_class: data.weight_class?.id,
            result: data.result,
          }}
        />
      </PageLayout.Section>
    </Fragment>
  );
});
